import React from "react";
import Breadcrumb from "components/shared/Breadcrumb/Breadcrumb";
import TableWithFilters from "components/shared/TableWithFilters/TableWithFilters";
import { strings } from "utils/constants/strings";
import { Loader } from "../../Common/Loader";
import useDDPoColumns from "./useDDPoColumns";
import { DD_PO_PAGES } from "./config";
import { DDPoPaymentModal, DDPoPageTabs } from "./DDPoViewElements";
import { DDPoDesktopPage, DDPoDesktopTitle } from "./styles.allDDPoView";

export default function AllDDPoViewDesktop({
  activePage,
  pageConfig,
  pageNumber,
  hasNextPage,
  showLoader,
  ddPoTableRowData,
  handlePageChange,
  goToPage,
  handleDownloadInvoice,
  handleViewDetails,
  handleViewPayment,
  selectedPayment,
  setSelectedPayment,
}) {
  const viewSource = activePage === DD_PO_PAGES.PENDING_INVOICE ? "pod" : "invoice";
  const columns = useDDPoColumns(activePage, { handleDownloadInvoice, handleViewDetails, handleViewPayment });

  return (
    <DDPoDesktopPage>
      <Breadcrumb items={[{ label: "Home" }, { label: strings.allDDPoHeader }]} />
      <DDPoDesktopTitle>{strings.allDDPoHeader}</DDPoDesktopTitle>
      <DDPoPageTabs pageConfig={pageConfig} activePage={activePage} onChange={handlePageChange} />
      {showLoader ? (
        <Loader />
      ) : (
        <TableWithFilters
          columns={columns}
          data={ddPoTableRowData}
          getRowId={(row) => row.id}
          isLoading={showLoader}
          emptyMessage="No purchase orders found"
          page={pageNumber}
          hasNextPage={hasNextPage}
          onPageChange={goToPage}
          onRowClick={(row) => handleViewDetails(row._raw, viewSource)}
        />
      )}
      <DDPoPaymentModal payment={selectedPayment} onClose={() => setSelectedPayment(null)} />
    </DDPoDesktopPage>
  );
}
